export type ChatFileAttachment = {
  file: File;
  id: string;
  textPreview?: string;
};

function isTextFile(file: File): boolean {
  return (
    file.type.startsWith("text/") ||
    file.name.endsWith(".txt") ||
    file.name.endsWith(".md")
  );
}

export async function createChatFileAttachments(
  files: File[],
): Promise<ChatFileAttachment[]> {
  return Promise.all(
    files.map(async (file) => {
      let textPreview: string | undefined;

      if (isTextFile(file)) {
        const text = await file.text();
        textPreview = text.slice(0, 50) + (text.length > 50 ? "..." : "");
      }

      return {
        file,
        id: crypto.randomUUID(),
        textPreview,
      };
    }),
  );
}
